<script lang="ts" setup>
import { useAppStore } from '../stores/app'
import { useContextsStore } from '../stores/contexts'

const appStore = useAppStore()
const contextsStore = useContextsStore()
const { t } = useI18n()

function handleLogin() {
  appStore.finishOnboarding()
  navigateTo('/auth')
}

async function handleFinishOnboarding() {
  appStore.finishOnboarding()
  const ctx = await contextsStore.addNewContext(t('contexts.defaults.life'))
  if (ctx) {
    await contextsStore.setCurrentContext(ctx)
  }
}
</script>

<template>
  <section
    class="fixed z-50 inset-0 bg-default/80 p-4 backdrop-blur-xl overflow-y-auto"
  >
    <div class="mx-auto max-w-2xl">
      <LogoIcon class="h-12 my-8 text-primary dark:text-primary mx-auto" />
      <h1 class="text-4xl font-bold mb-2">
        {{ $t('onboarding.title') }}
      </h1>
      <h2 class="font-bold text-2xl">{{ $t('onboarding.subtitle') }}</h2>
      <p
        v-for="(p, index) in $tm('onboarding.description')"
        :key="index"
        class="my-4"
      >
        {{ $rt(p) }}
      </p>
      <div role="menu" class="flex gap-4 mt-12 flex-col md:flex-row">
        <div class="flex-1 space-y-4">
          <UButton
            color="primary"
            variant="outline"
            size="xl"
            class="w-full"
            :label="$t('onboarding.start_offline')"
            @click="handleFinishOnboarding"
          />
        </div>
        <div class="flex-1 space-y-4">
          <UButton
            color="primary"
            variant="solid"
            class="w-full"
            size="xl"
            :label="$t('onboarding.start_cloud')"
            @click="handleLogin"
          />
        </div>
      </div>
    </div>
    <footer><InstallPwaButton size="xl" /></footer>
  </section>
</template>
